import React, { useState } from 'react';
import { get as _get } from 'lodash';
import { ProfileData, MapIntelligence, SavedProfile } from '../../types';
import CompanyCard from '../profile/CompanyCard';
//import LocationIntelligenceCard from '../profile/LocationIntelligenceCard';
import SignalHistory from '../profile/SignalHistory';
import Icon from '../common/Icon';

interface GeneralTabProps {
  profile: ProfileData;
  mapsIntel: MapIntelligence | null;
  isLoadingMaps: boolean;
  savedProfiles: SavedProfile[];
}

const GeneralTab: React.FC<GeneralTabProps> = ({
  profile,
  mapsIntel,
  isLoadingMaps,
  savedProfiles,
}) => {
  const company = _get(profile, 'company');
  const technographics = _get(profile, 'technographics') || null;
  const address = _get(profile, 'address') || '';
  const location = _get(profile, 'location') || '';
  const bio = _get(profile, 'bio') || '';
  const engagementHistory = _get(profile, 'engagementHistory') || [];

  const BIO_LIMIT = 450;
  const [bioExpanded, setBioExpanded] = useState(false);
  const bioTruncated = bio.length > BIO_LIMIT && !bioExpanded ? bio.slice(0, BIO_LIMIT) + '…' : bio;

  return (
    <div className="space-y-10 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-1 space-y-6">
          {company && (
            <CompanyCard
              company={company}
              address={address}
              location={location}
              technographics={technographics}
            />
          )}

          {/*<LocationIntelligenceCard
            address={address}
            location={location}
            mapsIntel={mapsIntel}
            isLoading={isLoadingMaps}
          />*/}

          {savedProfiles && savedProfiles.length > 0 && (
            <div className="bg-white border border-brand-grey01 rounded-brand p-8 shadow-sm">
              <h3 className="text-sm font-black mb-4 flex items-center gap-2 text-brand-black uppercase tracking-wider">
                <Icon name="folder_shared" className="text-brand-pink" size="sm" />
                Library ({savedProfiles.length})
              </h3>
              <div className="space-y-3">
                {(savedProfiles || []).map((p, i) => {
                  const name = _get(p, 'name', '');
                  const title = _get(p, 'title', '');
                  
                  return (
                    <div
                      key={i}
                      className="flex flex-col border-b border-brand-grey01 pb-2 last:border-0"
                    >
                      <p className="text-xs font-black">{name}</p>
                      <p className="text-[10px] text-brand-grey08">{title}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="lg:col-span-2">
          <SignalHistory events={engagementHistory} />

          {bio && (
            <div className="bg-brand-mustard p-8 rounded-brand shadow-sm relative overflow-hidden dot-pattern">
              <h4 className="text-[10px] font-extrabold uppercase mb-4 tracking-widest text-brand-black">
                Contact Summary
              </h4>
              <p className="text-brand-black font-medium leading-relaxed italic relative z-10 text-sm">
                "{bioTruncated}"
              </p>
              {bio.length > BIO_LIMIT && (
                <button
                  onClick={() => setBioExpanded((prev) => !prev)}
                  className="mt-3 text-[11px] font-extrabold uppercase tracking-wider text-brand-black underline underline-offset-2 hover:opacity-70 transition-opacity relative z-10"
                >
                  {bioExpanded ? 'Show less' : 'Read more...'}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
